var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"71","height":"91","viewBox":"0 0 71 91","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0.875V90.125L70.125 45.5L0 0.875Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }